// The MOBILE_ACCESS_ID 12 is "restrict mobile access" meaning:
// if they have the role they won't be able to access mobile access.
// if they don't have the role they CAN access the Weave mobile app.
// For additional context, this number is taken from:
// https://github.com/weave-lab/platform-webapp-customer/blob/2be1f0c123c3927b27733c65583edc8d7711b615/src/components/users-container/users/users.helper.ts#L36

import i18next from 'i18next';

export const MOBILE_ACCESS_ID = 12;
export const FORMS_ROLE_NAMES = {
  provider: 'Forms Provider',
  admin: 'Forms Manager',
};

export const FORMS_PROVIDER_REVIEW_ROLES = [FORMS_ROLE_NAMES.provider, FORMS_ROLE_NAMES.admin];

/**
 * We're using names when referring to roles (instead of using IDs) because the IDs are not consistent between dev and prod environments.
 * UUIDs would be stable, but we are not ready to use them yet
 */
export const EXCLUDED_ROLE_NAMES = [
  'Manage Schedule Settings',
  'View Schedule',
  'Manage Schedule',
  'Manage Online Scheduling',
  'Manage Calendar Events',
  'Verify Patient Insurance ',
  'Manage Insurance Verification Settings',
  'Override Insurance',
];

// we should be querying the backend for a list of recommended roles
export const RECOMMENDED_ROLES = [
  'View Analytics Dashboard',
  'View Call Intelligence Analytics',
  'Manage Review Settings',
  'View Forms Inbox',
  'Manage Port Requests',
  'View Port Requests',
  'Manage Invoices and Refunds',
  'Manage Overrides & Office Hours',
  'Insurance Verification Access',
];

export const DEFAULT_LEGACY_ROLES = ['Team Member'];

export const PARENT_ELIGIBLE_CATEGORIES = ['Location Settings', 'Organization Settings', 'Phones'];

export const ERROR_KEYS = {
  INVALID_EMAIL: 'INVALID_EMAIL',
  EMAIL_REQUIRED: 'EMAIL_REQUIRED',
  PERMISSION_REQUIRED: 'PERMISSION_REQUIRED',
  LOCATION_REQUIRED: 'LOCATION_REQUIRED',
  DUPLICATE_EMAIL: 'DUPLICATE_EMAIL',
  EXISTING_EMAIL: 'EXISTING_EMAIL',
} as const;

export const ERRORS = {
  [ERROR_KEYS.INVALID_EMAIL]: i18next.t('Invalid email address', { ns: 'account' }),
  [ERROR_KEYS.EMAIL_REQUIRED]: i18next.t('Email address is required', { ns: 'account' }),
  [ERROR_KEYS.PERMISSION_REQUIRED]: i18next.t('At least one permission is must be selected', { ns: 'account' }),
  [ERROR_KEYS.LOCATION_REQUIRED]: i18next.t('User needs to be added to at least one location', { ns: 'account' }),
  [ERROR_KEYS.DUPLICATE_EMAIL]: i18next.t('Duplicate email address', { ns: 'account' }),
  [ERROR_KEYS.EXISTING_EMAIL]: i18next.t('User with this email already exists', { ns: 'account' }),
} as const;
